module.exports = "<mat-toolbar class=\"header\">\n  <span class=\"spacer\"></span>\n  Disclaimer\n  <span class=\"spacer\"></span>\n</mat-toolbar>\n"